import { makeStyles } from '@mui/styles';
import AdminActions from './components/AdminActions';
import { Homeless } from 'types';
import MemberInfo from './components/MemberInfo';   

const useStyles = makeStyles(() => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '100px',
      padding: '30px 12% 120px 12%'
    }
}));

export interface MemberProfileAdminProps {
    homeless: Homeless;
}

const Admin: React.FC<MemberProfileAdminProps> = ({ homeless }) => {
    const classes = useStyles();
    
    return (
        <div className={classes.root}>
            <AdminActions homeless={homeless}/> 
            <MemberInfo homeless={homeless} />   
        </div>
    );
};

export default Admin; 
